import { Component, ElementRef, ViewChild, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators,FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/fromEvent';

import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { ConceptoModel, DefTipoiva } from './Concepto.model';
import { DefOtrconcepId } from './Concepto.model';

import { OpcionModel } from '../Global/Opcion.model';

import { ConfirmarEliminacionService } from '../Dialog/ConfirmarEliminacionService';


@Component({
	selector : 'concepto',
	templateUrl : './ConceptoIndex.component.html',
	styleUrls  : ['../../../../styles.css']
})


export class ConceptoIndexComponent {
	
	// ~~~~~ Variables para el manejo de permisos ~~~~~ //
	public btnAgregar:boolean;
	public btnEditar:boolean;
	public btnEliminar:boolean;
	public btnConsultar:boolean;
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

	public listaNegocios:Array<OpcionModel>;
	public listaPrefijos:Array<OpcionModel>;
	public conceptos:Array<ConceptoModel>;

	public form: FormGroup;
	public formErrors: any;
	public cnumcont:OpcionModel ;
	public ciddoc:OpcionModel ;


	public displayedColumns = ['Código Concepto', 'Descripción Concepto', 'Editar'];
	public dataDataBase:ConceptosDatabase;
	public dataSource:ExampleDataSource;

	public permisos:any;

	public ocultar: boolean = false;
	public mensaje: string = "";

	public bloquear:boolean = false;

	cnumcontControl = new FormControl();
	ciddocControl = new FormControl();
	cnumcontOptions: Observable<OpcionModel[]>;
	ciddocOptions: Observable<OpcionModel[]>;
	options = [];

	

	public contrato:string;
	public prefijo:string;
	public tipoP:string;

/*	public dataDataBase:NegociosDatabase;
	public dataSource:ExampleDataSource;
	*/
	@ViewChild('filter') filter: ElementRef;



	constructor(private formBuilder: FormBuilder, private _serviciosGenerales:ServiciosGenerales, public snackBar: MatSnackBar,
		private _route: ActivatedRoute, private _router:Router, public dialog: MatDialog, private confirmarEliminacionService:ConfirmarEliminacionService){		

		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnAgregar = _serviciosGenerales.seguridad.isAgregar();
		this.btnEditar = _serviciosGenerales.seguridad.isEditar();
		this.btnEliminar = _serviciosGenerales.seguridad.isEliminar();
		this.btnConsultar = _serviciosGenerales.seguridad.isConsultar();
		
		this.snackBar.dismiss();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		
		this.listaNegocios = new Array();
		this.listaPrefijos = new Array();
		//this.permisos = _serviciosGenerales.seguridad.getCrud();
		//console.log('Permisos: ', this.permisos);

		this.cnumcont = new OpcionModel("","");
		this.ciddoc = new OpcionModel("","");

		this.form = this.formBuilder.group({
			filtroCnumcont   : [
			{
				value   : this.cnumcont.labelOpcion,
				disabled: this.bloquear
			}],
			filtroCiddoc   : [
			{
				value   : this.ciddoc.labelOpcion,
				disabled: this.bloquear
			}]
		});
		
	}


	ngOnInit(){
		console.log('CARGA EL FORMULARIO ........ ');
		//this.cargarTabla();

		this._serviciosGenerales.get('listaNegocios', {ntipoempresa : -1}).subscribe(
			
			result=>{
				for(let x in result)
					this.listaNegocios.push(new OpcionModel(result[x].cnumcont.trim(), result[x].vnombrenegocio.trim()));
				

				this.cnumcontOptions = this.cnumcontControl.valueChanges
				.startWith(null)
				.map(val => val ? this.filtro(val) : this.listaNegocios.slice());

				this._route.params.subscribe(params=>{
					console.log(params);
					if( !!params["cnumcont"]){
						this.tipoP = params["edi"];
						this.contrato = params["cnumcont"];
						this.prefijo = params["cprefijo"];
						for(let x in result)
							if(result[x].cnumcont.trim() == params["cnumcont"].trim())
								this.cnumcont.labelOpcion = result[x].cnumcont.trim()+' - '+result[x].vnombrenegocio.trim();
							if(!!params["ccodcon"] )
								this.eventoConsulta(params["ccodcon"]);

							if(!!params["cprefijo"] )
								this.eventoConsulta(params["cprefijo"]);
					}

				});

			},
			error=>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar la lista de negocios", "X");
			});

		
		this.listaPrefijos.push(new OpcionModel("", ""));

		this.ciddocOptions = this.ciddocControl.valueChanges
		.startWith(null)
		.map(val => val ? this.filtroPrefijo(val) : this.listaPrefijos.slice());


	}


	private inicializarLista(cnumcont, ccodcon){
		
		this.cnumcont.labelOpcion = cnumcont;

	}


	filtro(val: string)//: string[]
	{
		if(val == null){
			val = "";
		}


		let x = this.listaNegocios.filter(option =>(option.idOpcion.toLowerCase().trim() + option.labelOpcion.toLowerCase().trim()).indexOf(val.toLowerCase()) > -1); 
		
		return x;

		
	}



	filtroPrefijo(val: string)//: string[]
	{
		if(val == null){
			val = "";
		}


		let x = this.listaPrefijos.filter(option =>(option.idOpcion.toLowerCase().trim() + option.labelOpcion.toLowerCase().trim()).indexOf(val.toLowerCase()) > -1); 
		
		return x;

		
	}

	eventoConsulta(opcional){
		
		this.cnumcont.idOpcion = this.cnumcont.labelOpcion.substring(0,this.cnumcont.labelOpcion.indexOf('-')).trim();
		this.listaPrefijos = new Array();
		this.ciddoc = new OpcionModel(" ", " ");
		this.eventoConsultaConceptos();
		

		this._serviciosGenerales.get('listaPrefijos', {cnumcont : this.cnumcont.idOpcion, ntipoempresa : -1}).subscribe(
			
			result=>{
				for(let x in result)
					this.listaPrefijos.push(new OpcionModel(result[x].cprefijo.trim(), result[x].cprefijo.trim()));
				
				if(this.listaPrefijos.length == 0){
					this.openSnackBarEspecial("No se encontraron prefijos para el contrato : "+this.cnumcont.idOpcion, "X");
					return;
				}
				else
					this.snackBar.dismiss();


				this.ciddocOptions = this.ciddocControl.valueChanges
				.startWith(null)
				.map(valT => valT ? this.filtroPrefijo(valT) : this.listaPrefijos.slice());


				if(opcional != undefined && opcional != ''){
					this.ciddoc.idOpcion = opcional+' - '+opcional;
					this.eventoConsultaConceptos();
				}

				//console.log(this.ciddoc);

			},
			error=>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los prefijos", "X");
			});
	}


	eventoConsultaConceptos(){
		let prefijo = this.ciddoc.idOpcion.substring(0,this.ciddoc.idOpcion.indexOf('-')).trim();
		

		console.log('ENTRA A HACER PETICIÓNN  ');
		this._serviciosGenerales.get('listadoConceptosIndex', { cnumcont : this.cnumcont.idOpcion.trim(), ciddoc : prefijo, ntipoempresa : -1}).subscribe(

			result=>{
				this.dataDataBase = new ConceptosDatabase();
				this.dataDataBase.clear();
				this.dataSource = new ExampleDataSource(this.dataDataBase);
				//console.log(result);
				for(let x in result){
					console.log('ITERA!!! ..... ',x);
					this.dataDataBase.addConcepto(
						new ConceptoModel(new DefOtrconcepId(result[x].ccodcon, this.cnumcont.idOpcion.trim(), result[x].ciddoc), result[x].cdescon, "", "", "", "", new DefTipoiva(''),0,0,"",0,"",0)
						);
				}
				this.dataSource = new ExampleDataSource(this.dataDataBase);
			},
			error=>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los conceptos", "X");
			});
	}


	consultarPrefijos(){
//		console.log('Entró .... ', this.cnumcont);
this._serviciosGenerales.get('listadoPrefijos', {cnumcont:this.cnumcont.idOpcion}).subscribe(


	result=>{
		this.listaPrefijos = new Array();
		for(let x in result)
			this.listaPrefijos.push(new OpcionModel(result[x].cprefijo.trim(), result[x].cprefijo.trim()));

	},
	error=>{
		var errorMensaje = <any>error;
		console.log('Error al enviar la peticion ', errorMensaje);
		this.openSnackBarEspecial("Ocurrió un error al momento de cargar el prefijo", "X");
	}
	);
}


editar(concepto : ConceptoModel){
	this._router.navigate(['/Concepto', 1, concepto.id.cnumcont.trim(), concepto.id.ccodcon.trim(), concepto.id.ciddoc.trim()]);

}

agregar(){
	let x = this.cnumcont.idOpcion;
	if(x == undefined || x.replace("-", "").trim() == '' ){
		this.openSnackBarEspecial("Hay que seleccionar un contrato", "X");
		return;
	}

	let negocioTemp = this.cnumcont.labelOpcion.substring(0,this.cnumcont.labelOpcion.indexOf('-')).trim();
	let conteo = 0;
	for(let y in this.listaNegocios){
		if(negocioTemp == this.listaNegocios[y].idOpcion){
			conteo = conteo + 1;
		}
	}

	if(conteo == 0){
		this.openSnackBarEspecial("Hay que seleccionar un contrato válido", "X");
		return;
	}

	x = this.ciddoc.idOpcion;

	if(x == undefined || x.replace("-", "").trim() == '' ){
		this.openSnackBarEspecial("Hay que seleccionar un prefijo", "X");
		return;
	}

	let prefijo = this.ciddoc.idOpcion.substring(0,this.ciddoc.idOpcion.indexOf('-')).trim();
	for(let y in this.listaPrefijos){
		if(this.listaPrefijos[y].idOpcion.trim() == prefijo){
			this._router.navigate(['/Concepto', 0, this.cnumcont.idOpcion.trim(), prefijo]);		
			return;
		}
	}

	this.openSnackBarEspecial("Hay que seleccionar un prefijo válido", "X");

}

eliminar(concepto:ConceptoModel){
	
	this.confirmarEliminacionService.abrirDialog({ccodcon : concepto.id.ccodcon, cnumcont : concepto.id.cnumcont, ciddoc : concepto.id.ciddoc, ntipoempresa : -1}, 'eliminarConcepto');
	this.confirmarEliminacionService.eventoFin$.subscribe(r=>{
		this.eventoConsultaConceptos();
	})
}

openSnackBar(message: string, action: string)
{
	this.snackBar.open(message, action, {
		duration: 20000
	});
}

openSnackBarEspecial(message: string, action: string) {
	let snackBarRef =  this.snackBar.open(message, action);

	snackBarRef.onAction().subscribe(() => {
		console.log("Paso por aqui 1 notas");

		this.ocultar = false;
		this.mensaje = "";
	});
	
	let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
	
	if (shand.length != 0) {
			for (let i=0;i<shand.length;i++){
			shand[i].style.backgroundColor = "rgb(255 204 214)";
			}
		}
}

}





// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

export class ConceptosDatabase
{
	
	dataChange: BehaviorSubject<ConceptoModel[]> = new BehaviorSubject<ConceptoModel[]>([]);

	get data(): ConceptoModel[]
	{
		return this.dataChange.value;
	}

	addConcepto(concepto:ConceptoModel)
	{
		const copiedData = this.data.slice();
		copiedData.push(concepto);
		this.dataChange.next(copiedData);
	}

	clear(){
		this.dataChange = new BehaviorSubject<ConceptoModel[]>([]);
	}

}



export class ExampleDataSource extends DataSource<any>
{
	_filterChange = new BehaviorSubject('');

	get filter(): string
	{
		return this._filterChange.value;
	}

	set filter(filter: string)
	{
		this._filterChange.next(filter);
	}

	constructor(private _exampleDatabase: ConceptosDatabase)
	{
		super();
	}

	/** Connect function called by the table to retrieve one stream containing the data to render. */
	connect(): Observable<ConceptoModel[]>
	{
		const displayDataChanges = [
		this._exampleDatabase.dataChange,
		this._filterChange
		];
		return Observable.merge(...displayDataChanges).map(() => {
			return this._exampleDatabase.data.slice().filter((item: ConceptoModel) => {
				let searchStr = (item.id.ciddoc).toLowerCase();
				return searchStr.indexOf(this.filter.toLowerCase()) != -1;
			});
		});
	}

	disconnect()
	{
	}
}



// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/CrearConcepto/ConceptoIndex.component.ts